import { render, staticRenderFns } from "./CustomerDialogMultiSelectCustomer.vue?vue&type=template&id=3d217208&scoped=true&"
import script from "./CustomerDialogMultiSelectCustomer.vue?vue&type=script&lang=ts&"
export * from "./CustomerDialogMultiSelectCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d217208",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VCombobox,VListItem})
